import { AuthorityTreeType } from '@/constant/apiEnum';

function hasChildren(children) {
  return children.length > 0;
}
function isButton(type) {
  return type === AuthorityTreeType.BUTTON;
}

export function filterMenuTree(tree) {
  return tree.filter((node) => {
    if (node.children) {
      // eslint-disable-next-line no-param-reassign
      node.children = filterMenuTree(node.children);
    }
    return node.type !== 2;
  });
}

export function recursionButtonMap(result, list, existNodes) {
  list.forEach((item) => {
    if (isButton(item.type)) {
      // eslint-disable-next-line no-param-reassign
      if (!result[item.parentId]) result[item.parentId] = [];
      result[item.parentId].push({
        ...item,
        checked: existNodes.includes(item.id),
      });
    }
    if (!isButton(item.type) && hasChildren(item.children)) {
      recursionButtonMap(result, item.children, existNodes);
    }
  });
}
